export default __webpack_public_path__ + "static/media/WhatsApp Community_UAQ.9ff4b6fa.png";